import React from 'react'
import exportToPdf from "../../../../../core/gd-app/import-export/export-to-pdf";

type Props = {
    hideIcon    : boolean
    hidePopover : {():void}
    onClick?    : func
}

export default function ExportToPdfOption(props:Props) {

    const isPro = gd.session.companies.get(gd.companyId).license.isPro;

    const onClick = () => {
        if (props.onClick) {
            props.onClick()
        } else {
            exportToPdf(gd.getApp())
        }

        props.hidePopover()
    };

    const onClickUpgrade = () => {
        gd.modals.other.upgradeToPro(gd.companyId);
        props.hidePopover();
    };

    return (
        <div className="option with-icon" onClick={isPro ? onClick : onClickUpgrade}>
            <div className={Classes('ico', {'i5-pdf': !props.hideIcon})}/>
            <div className="label">Export to PDF</div>
            {!isPro && <div className="ui5-ico-pro"/>}
        </div>
    )
}